import React from "react";
import { Image } from "../styles/components/Galleries/Global";

const ImageDisplay = ({ src, mobile, quote }) => {
  return (
    <>
      <Image src={src} $desktop={mobile} />
      {mobile && <Image src={mobile} $mobile $quote={quote} />}
    </>
  );
};

export default ImageDisplay;
